//--------------- IMPORTAÇÕES ---------------//
import { useContext, useEffect } from "react";
import { X } from "lucide-react";
import { TrackingContext } from "../../context/TrackingContext";
import { loadEventsTrackingService } from "../../services";
import { formatterDateAndTime } from "../../../../shared/utils"



//--------------- EXPORTAÇÃO DO MODAL EVENTS TRACKING ---------------//
export default function ModalEventsTracking() {



  //--------------- CRIAÇÃO DE HOOKS ---------------//
  const { events, setEvents } = useContext(TrackingContext); // Estado que armazena a lista de eventos existentes
  const { isOpenModalEventsTracking, setIsOpenModalEventsTracking } = useContext(TrackingContext);
  const { formDataModalEventTracking, setFormDataModalEventTracking } = useContext(TrackingContext); // Estado que armazena o ID do Visitor Selecionado pelo usuário
  const { isLoadingModalEventTracking, setIsLoadingModalEventTracking } = useContext(TrackingContext);




  //--------------- USE EFFECT QUE ATUALIZA A CADA MUDANÇA DO FORM DATA DO MODAL EVENTOS TRACKING ---------------//
  useEffect(() => {
  }, [formDataModalEventTracking]);



  //---------------- FUNÇÃO ASSÍNCRONA HANDLE LOAD EVENTS TRACKING ------------------//
  // async function handleLoadEventsTracking() {
  //   setIsLoadingModalEventTracking(true);
  //   const response = await loadEventsTrackingService(formDataModalEventTracking.id)
  //   if (response) {
  //     setEvents(response.data)
  //   } else {
  //     setEvents([])
  //   }
  //   setIsLoadingModalEventTracking(false);
  // }



  //---------------- RETORNO CONDICIONAL DO MODAL EVENTS TRACKING ------------------//
  return (
    <>
      {!isOpenModalEventsTracking && !formDataModalEventTracking.id
        ? null
        :
        <>
          <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
            <div className="bg-surface-1 border border-white/[0.08] rounded-xl w-full max-w-6xl p-6 max-h-[90vh] overflow-y-auto">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold">Eventos para Visitor ID: <span className="text-brand-400">{formDataModalEventTracking.id}</span></h2>
                <button onClick={() => {
                  setFormDataModalEventTracking({});
                  setIsOpenModalEventsTracking(false);
                }}><X className="text-white" /></button>
              </div>


              <table className="min-w-full text-sm text-white">
                <thead className="bg-surface-3">
                  <tr>
                    <th className="p-2 text-left">Data</th>
                    <th className="p-2 text-left">Evento</th>
                    <th className="p-2 text-left">URL Limpa</th>
                    {/* <th className="p-2 text-left">utm_source</th>
                    <th className="p-2 text-left">utm_medium</th>
                    <th className="p-2 text-left">utm_campaign</th>
                    <th className="p-2 text-left">utm_content</th>
                    <th className="p-2 text-left">utm_term</th> */}
                    {/* <th className="p-2 text-left">Email</th> */}
                    {/* <th className="p-2 text-left">Nome</th> */}
                    <th className="p-2 text-left">Status Venda</th>
                  </tr>
                </thead>
                <tbody>
                  { events.find(ev => ev.visitor_id === formDataModalEventTracking.id)?.eventos?.map((ev, idx) => (
                    <tr key={idx} className="border-b border-white/[0.08]">
                      {/* <td className="p-2">{new Date(ev.data_evento * 1000).toLocaleString()}</td> */}
                      <td className="p-2">{formatterDateAndTime(ev.data_evento)}</td>
                      <td className="p-2">{ev.evento}</td>
                      <td className="p-2 break-all">{ev.url ? ev.url.split("?")[0] : "-"}</td>
                      {/* <td className="p-2">{ev.utm_source || '-'}</td>
                        <td className="p-2">{ev.utm_medium || '-'}</td>
                        <td className="p-2">{ev.utm_campaign || '-'}</td>
                        <td className="p-2">{ev.utm_content || '-'}</td>
                        <td className="p-2">{ev.utm_term || '-'}</td> */}
                      {/* <td className="p-2">{ev.email || '-'}</td> */}
                      <td className="p-2">{ev.status_venda || '-'}</td>
                      {/* <td className="p-2">{ev.nome || '-'}</td> */}
                    </tr>
                  ))}
                </tbody>
              </table>


            </div>
          </div>
        </>
      }
    </>
  )
}